package shared.business.feature.comment

import org.koin.dsl.module

internal val commentModule = module {
}
